import {
  RETRIEVE_STUDENT_LIST_PICKUP_SCHEDULE,
  RETRIEVE_STUDENT_LIST_DROP_SCHEDULE,
  RETRIEVE_MASTER_DATA_SCHEDULE,
  UPDATE_SCHEDULE_DETAIL,
  RETRIEVE_DROP_ROUTE_TIMES,
  RETRIEVE_STUDENT_SCHEDULE_LIST,
  EXPORT_CANCELS,
  CREATE_CANCEL,
  DELETE_CANCEL,
  CREATE_TEMPLATE,
  GET_DETAIL_TEMPLATE,
  DELETE_TEMPLATE,
  RETRIEVE_TEMPLATE_LIST,
  UPDATE_TEMPLATE,
  GET_MASTER_TEMPLATE,
  RETRIEVE_MASTER_STUDENT_LIST_NO_FILTER,
  RETRIEVE_SCHEDULE_TEMPLATE_STUDENT_LIST,
  RETRIEVE_SCHEDULE_TEMPLATE_STUDENT_LIST_ALL,
  RETRIEVE_STUDENT_LIST_PICKUP_SCHEDULE_UPDATE
} from '@/api'

import { CREATE_PICKUP_SCHEDULE,GET_PICKUP_SCHEDULE } from '@/api/phase2/pickupTemplate'
export default {

  retrievePickupStudentList({commit}, payload) {
    let errorCallback = typeof payload.errorCallback !== 'undefined' ? payload.errorCallback : null
    let successCallback = (response) => {
      if (response.data.data.student_list.length) {
        commit('retrievePickupStudentList', {studentList: response.data.data.student_list})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_STUDENT_LIST_PICKUP_SCHEDULE({}, successCallback, errorCallback)
  },
  retrievePickupStudentListUpdate({commit}, payload) {
    let date = payload.date
    let dateGenerate = payload.dateGenerate || null
    let errorCallback = typeof payload.errorCallback !== 'undefined' ? payload.errorCallback : null
    let successCallback = (response) => {
      let date = payload.date
      if (response.data.data.student_list.length) {
        let dataResult = []
        response.data.data.student_list.map(el=>{
          let data = Object.assign({}, el)
          data.bus_id = el.student_pickup_routes ? el.student_pickup_routes.bus_id : ""
          data.time= el.student_pickup_routes ? el.student_pickup_routes.time : ""
          data.sub_driver_id =  el.student_pickup_routes ? el.student_pickup_routes.sub_driver_id : ""
          data.can_pick = el.place_id ? true :  false
          dataResult.push(data)
        })
        if(dateGenerate){
          commit('retrievePickupStudentListUpdate', {studentList: dataResult , date:dateGenerate })
        }else{
          commit('retrievePickupStudentListUpdate', {studentList: dataResult , date })
        }

      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_STUDENT_LIST_PICKUP_SCHEDULE_UPDATE({date}, successCallback, errorCallback)
  },

  retrieveDropStudentList({ commit }, payload) {
    let date = payload.date

    let errorCallback = typeof payload.errorCallback !== 'undefined' ? payload.errorCallback : null
    let successCallback = (response) => {
      if (response.data.data.student_list) {
        commit('retrieveDropStudentList', {studentList: response.data.data.student_list, date})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_STUDENT_LIST_DROP_SCHEDULE({date}, successCallback, errorCallback)
  },

  retrieveDropRouteTimes({ commit, state }, payload) {
    let date = payload.date

    if (typeof state.dropRouteTimes[date] !== 'undefined') {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    } else {
      let errorCallback = typeof payload.errorCallback !== 'undefined' ? payload.errorCallback : null
      let successCallback = (response) => {
        if (response.data.data.times) {
          commit('retrieveDropRouteTimes', {times: response.data.data.times, date})
        }

        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }

      RETRIEVE_DROP_ROUTE_TIMES({date}, successCallback, errorCallback)
    }
  },

  retrieveMasterData({commit}, payload) {
    let errorCallback = typeof payload.errorCallback !== 'undefined' ? payload.errorCallback : null
    let successCallback = (response) => {
      if (response.data.data) {
        commit('retrieveMasterData', {masterData: response.data.data})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_MASTER_DATA_SCHEDULE({}, successCallback, errorCallback)
  },

  updateScheduleDetail({commit, state}, payload) {
    let errorCallback = typeof payload.errorCallback !== 'undefined' ? payload.errorCallback : null
    let successCallback = () => {
      commit('updateScheduleDetail')

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    // let pickupStudentList = state.pickupStudentList.map((student) => {
    //   return {
    //     id: student.id,
    //     bus_id: student.bus_id,
    //     time: student.time || '',
    //     sub_driver_id: student.sub_driver_id
    //   }
    // })
    let pickupStudentList = {}
    for (let date in state.pickupStudentListUpdate) {
      pickupStudentList[date] = state.pickupStudentListUpdate[date].map((student) => {
        return {
          id: student.id,
          bus_id: student.bus_id,
          time: student.time ? student.time.substring(0,5) : '',
          sub_driver_id: student.sub_driver_id,
        }
      })
    }
    if(payload.dataStudentPickup){
      for (let dat in payload.dataStudentPickup) {
        if(!pickupStudentList[dat]){
          pickupStudentList[dat] = []
          for (let key in payload.dataStudentPickup[dat]) {
            let value = payload.dataStudentPickup[dat][key]
            pickupStudentList[dat].push({
              id: value.id,
              bus_id: value.bus_id,
              time: value.time ? value.time.substring(0,5) : '',
              sub_driver_id: value.sub_driver_id
            })
          }
        }

      }
    }
    let dropStudentList = {}

    for (let date in state.dropStudentList) {
      dropStudentList[date] = state.dropStudentList[date].map((student) => {
        return {
          id: student.id,
          bus_id: student.bus_id,
          time: student.time || '',
          sub_driver_id: student.sub_driver_id,
        }
      })
    }
    if(payload.dataStudent){
      for (let dat in payload.dataStudent) {
        if(!dropStudentList[dat]){
          dropStudentList[dat] = []
          for (let key in payload.dataStudent[dat]) {
            let value = payload.dataStudent[dat][key]
            dropStudentList[dat].push({
              id: value.id,
              bus_id: value.bus_id,
              time: value.time || '',
              sub_driver_id: value.sub_driver_id
            })
          }
        }

      }
    }

    let data = {
      pickup_student_list: {},
      drop_student_list: dropStudentList,
      drop_route_times: state.dropRouteTimes
    }

    UPDATE_SCHEDULE_DETAIL({ data }, successCallback, errorCallback)
  },

  retrieveStudentScheduleList(commit, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    let date = payload.date || null

    RETRIEVE_STUDENT_SCHEDULE_LIST({ date }, successCallback, errorCallback)
  },

  exportCancels(state, payload) {
    let errorCallback = null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    EXPORT_CANCELS(payload, successCallback, errorCallback)
  },

  createCancel (state, payload) {
    let errorCallback = null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    CREATE_CANCEL(payload.data, successCallback, errorCallback)
  },

  deleteCancel (state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    DELETE_CANCEL(payload.id, successCallback, errorCallback)
  },


  retrieveStudentMasterListNoFilter({ commit }, payload) {
    let errorCallback = typeof payload.errorCallback !== 'undefined' ? payload.errorCallback : null
    let successCallback = (response) => {
      if (response.data.student_list) {
        commit('retrieveStudentListNoFilter', {studentListNoFilter: response.data.student_list})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_MASTER_STUDENT_LIST_NO_FILTER(successCallback, errorCallback)
  },

  retrieveTemplateList(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_TEMPLATE_LIST(payload, successCallback, errorCallback)
  },

  createTemplate(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
  CREATE_TEMPLATE(payload.data, successCallback, errorCallback)
  },
  updateTemplate(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    UPDATE_TEMPLATE(payload.data, successCallback, errorCallback)
  },
  getDetailTemplate(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    GET_DETAIL_TEMPLATE(payload.data, successCallback, errorCallback)
  },
  deleteTemplate(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    DELETE_TEMPLATE(payload, successCallback, errorCallback)
  },
  getMasterTemplate(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    GET_MASTER_TEMPLATE(payload, successCallback, errorCallback)
  },

  retrieveTemplateStudentList(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_SCHEDULE_TEMPLATE_STUDENT_LIST(payload, successCallback, errorCallback)
  },

  retrieveTemplateStudentListAll(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_SCHEDULE_TEMPLATE_STUDENT_LIST_ALL(payload, successCallback, errorCallback)
  },
  createPickupSchedule({ commit, state }, payload) {
    let errorCallback = typeof payload.errorCallback !== 'undefined' ? payload.errorCallback : null
    let successCallback = () => {
      commit('updateScheduleDetail')

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    let pickupStudentList = []
    for(let date in state.pickupStudentListUpdate){
      pickupStudentList = state.pickupStudentListUpdate[date].map((student) => {
        return {
          id: student.id,
          bus_id: student.bus_id || null,
          time: student.time ? student.time.substring(0,5) : null,
          sub_driver_id: student.sub_driver_id || null,
        }
      })
    }
    let currentDate = payload.date
    if(payload.dataStudentPickup){
      for (let key in payload.dataStudentPickup[currentDate]) {
        let value = payload.dataStudentPickup[currentDate][key]
        let student ={
          id: value.id,
          bus_id: value.bus_id,
          time: value.time ? value.time.substring(0,5) : '',
          sub_driver_id: value.sub_driver_id
        }
        let indexStudent = pickupStudentList.findIndex(el=> el.id === value.id)
        if(indexStudent >-1){
          pickupStudentList[indexStudent] = student
        }
      }
    }
    let data = {
      date : currentDate,
      pickup_student_list: pickupStudentList
    }
    CREATE_PICKUP_SCHEDULE({ data }, successCallback, errorCallback)
  },
  getPickupScheduleByDate({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    GET_PICKUP_SCHEDULE({ payload }, successCallback, errorCallback)
  },

}
